import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';

import './ComplianceBadges.css';

export function ComplianceBadges(): ReactElement {
  return (
    <div className="compliance-badges" role="contentinfo" aria-label={t('common.compliance.badgesLabel')}>
      <a
        href="https://www.rtalabel.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="compliance-badges__badge"
      >
        <span className="compliance-badges__rta" aria-hidden>
          RTA
        </span>
        <span className="compliance-badges__text">{t('common.compliance.rta')}</span>
      </a>
      <a
        href="https://www.asacp.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="compliance-badges__badge"
      >
        <span className="compliance-badges__asacp" aria-hidden>
          ASACP
        </span>
        <span className="compliance-badges__text">{t('common.compliance.asacp')}</span>
      </a>
    </div>
  );
}
